import { Box, Button, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LeftArrowIcon, LogoShapeIconWhite, LogoTextIconWhite, LogoutIcon } from "../../../assets/icons";
import theme, { getTenant } from "../../../theme";
import { useMediaQuery } from "@react-hook/media-query";
import { checkEmptyObj } from "../../../utils";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import useLogin from "../../Auth/useLogin";
import { useTranslation } from "react-i18next";

export default function Type3() {
  const { t, i18n } = useTranslation('mobileHeader');
  const isRTL = i18n.dir() === 'rtl';
  const tenant = getTenant();
  const navigate = useNavigate();
  const { logout } = useLogin();
  const user = useSelector((state: RootState) => state.user);
  return (
    <Box className="mobile-header type3" sx={{ height: "60px", padding: "14px 16px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
        <Link to={"/"} style={{ display: "flex", gap: "8px", justifyContent: "center", width: "100%" }}>
          <Box
            sx={{
              backgroundImage: `url(../../${tenant.name}/logoWhiteHorizontal.svg)`,
              height: `28px`,
              width: `100%`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: isRTL ? "right center" : "left center",
            }}
          />
        </Link>
        {checkEmptyObj(user) ? (
          <Button
            onClick={() => navigate("/login")}
            sx={{
              backgroundColor: "var(--primary-lighter)",
              color: "var(--primary-dark)",
              padding: "8px 16px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
            }}
          >
            {t("loginButton")}
          </Button>
        ) : (
          <Box
            sx={{
              borderRadius: "90px",
              padding: "13px",
              color: "var(--body-bg)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={logout}
          >
            <LogoutIcon />
          </Box>
        )}
      </Box>
    </Box>
  );
}
